var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ButtonIconContextual',{attrs:{"label":_vm.computedAriaLabel,"size":"small","data-testid":"watchlist-button","icon":_vm.buttonIcon},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.toggleWatchList.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }